import { useLoggedIn } from '@moonpig/web-core-auth'
import { useEffect } from 'react'
import { useApolloClient } from '@moonpig/web-core-graphql'
import { destroyBrowserCookie } from '@moonpig/web-core-browser-storage'
import { useExperiment } from '@moonpig/web-core-eppo/browser'
import { logger } from '@moonpig/web-core-monitoring'
import { queryUserData } from './queryUserData'

const INTERCOM_APP_ID = 'ptt17buv'

export const CreateIntercomSession = () => {
  const client = useApolloClient()
  const { loggedIn } = useLoggedIn()

  const featureEnabled = useExperiment('customer-intercom-user-session', {
    fallback: false,
  })

  useEffect(() => {
    let isCancelled = false

    if (loggedIn && featureEnabled) {
      const createIntercomSession = async () => {
        try {
          const userData = await queryUserData(client.query)
          const intercomModule = await import('@intercom/messenger-js-sdk')
          const { userDataJwt } = userData.intercom

          if (isCancelled) return

          intercomModule.default({
            region: 'eu',
            app_id: INTERCOM_APP_ID,
            hide_default_launcher: true,
            user_id: userData.id,
            email: userData.email,
            intercom_user_jwt: userDataJwt,
          })
        } catch (error) {
          logger.warning('Could not create Intercom session', {}, error)
        }
      }

      createIntercomSession()
    } else {
      destroyBrowserCookie(`intercom-session-${INTERCOM_APP_ID}`, {
        path: '/',
      })
    }

    return () => {
      isCancelled = true
    }
  }, [client.query, loggedIn, featureEnabled])

  return null
}
